"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const index_1 = require("../../index");
const windowWidth_1 = require("../../utils/windowWidth");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const Logo_1 = __importDefault(require("../Logo/Logo"));
const OrganizationDropdown_1 = __importDefault(require("./Dropdown/OrganizationDropdown"));
const HamburgerIcon_1 = __importDefault(require("./HamburgerIcon/HamburgerIcon"));
const MenuIcon_1 = __importDefault(require("./MenuIcon/MenuIcon"));
const ModeSelector_1 = __importDefault(require("./ModeSelector"));
const Menu = (props) => {
    const isTabletOrMobile = windowWidth_1.useIsTabletOrMobile();
    const [collapsable, setCollapsable] = React.useState(isCollapsable());
    const [collapsed, setCollapsed] = React.useState(getInitialCollapsedState());
    const [transitioning, setTransitioning] = React.useState(false);
    const toggleCollapsed = () => {
        setTransitioning(true);
        setCollapsed(!collapsed);
        setCollapsedCookie(!collapsed);
        // Make sure items don't appear before there is room
        setTimeout(() => {
            setTransitioning(false);
        }, 400);
    };
    React.useEffect(() => {
        setCollapsable(isCollapsable());
    }, [props.type === 'DATA' && props.availableModes]);
    React.useEffect(() => {
        if (isTabletOrMobile) {
            setTransitioning(false);
            setCollapsed(false);
        }
        else {
            props.closeMobileMenu();
            setCollapsed(getInitialCollapsedState());
        }
    }, [isTabletOrMobile]);
    React.useEffect(() => {
        var _a;
        (_a = props.setIsMenuCollapsed) === null || _a === void 0 ? void 0 : _a.call(props, collapsed);
    }, [collapsed]);
    const mode = props.currentMode;
    const location = react_router_dom_1.useLocation();
    const className = classnames_1.default({
        'aio-menu': true,
        [`aio-menu-${mode}`]: true,
        'aio-menu-collapsable': collapsable,
        'aio-menu-collapsed': collapsed,
        'aio-menu-open': props.open,
        'aio-menu-transitioning': transitioning,
    });
    const color = mode === 'landlord' || mode === 'operator' || mode === 'developer' ? 'white' : 'blue';
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "top-container" },
            props.open ? React.createElement("div", null) : React.createElement(Logo_1.default, { color: color, monogram_logo: collapsed || transitioning }),
            React.createElement("div", { onClick: props.toggleOpen, className: "mobile-icon" },
                React.createElement(HamburgerIcon_1.default, { open: props.open, color: color }))),
        React.createElement("div", { className: "bottom-container" }, renderModeSelectorAndOrganizationalDropdown()),
        React.createElement("button", { className: "collapse-button", onClick: toggleCollapsed, type: "button" },
            React.createElement(Icon_1.default, { icon: collapsed ? 'menu_arrow_right' : 'menu_arrow_left' }))));
    function renderModeSelectorAndOrganizationalDropdown() {
        if (props.type === 'LOADING') {
            return (React.createElement("div", { style: { alignSelf: 'center' } },
                React.createElement(index_1.Spinner, { size: collapsed ? 'sm' : 'md', delay: "long", color: color === 'white' ? 'white' : 'purple' })));
        }
        if (props.type === 'ERROR') {
            return (React.createElement("div", { className: "text-helper", style: { alignSelf: 'center' } },
                React.createElement(index_1.Message, { type: "error", message: props.message })));
        }
        if (props.impersonationController) {
            return (React.createElement(React.Fragment, null,
                props.impersonationController,
                renderAvailableMenuItems()));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement(ModeSelector_1.default, { collapsed: collapsed, transitioning: transitioning, currentMode: props.currentMode, availableModes: props.availableModes }),
                React.createElement("div", { className: "bottom-container-inner" },
                    React.createElement("div", { className: "dropdown-container" }, props.organization && React.createElement(OrganizationDropdown_1.default, { current: props.organization.current, organizations: props.organization.organizations, setCurrentOrganization: props.organization.setCurrentOrganization, mode: props.currentMode, collapsed: collapsed, transitioning: transitioning })),
                    renderAvailableMenuItems())));
        }
    }
    function renderAvailableMenuItems() {
        const active = activeUrl(props.items);
        const items = props.items.reduce((menuItems, currentMenuItem) => {
            // Empty list means no role restriction
            if (currentMenuItem.validRoles.length === 0) {
                menuItems.push(Object.assign(Object.assign({}, currentMenuItem), { active: currentMenuItem.url === active }));
            }
            else if (props.organization !== undefined &&
                props.organization.current.roles.some((role) => currentMenuItem.validRoles.includes(role))) {
                menuItems.push(Object.assign(Object.assign({}, currentMenuItem), { active: currentMenuItem.url === active }));
            }
            return menuItems;
        }, []);
        return (React.createElement("ul", { className: "menu-list" },
            items.map((el) => {
                const inner = (React.createElement(React.Fragment, null,
                    React.createElement(MenuIcon_1.default, { type: "ICON", icon: el.icon }),
                    React.createElement("div", { className: "menu-item-inner" },
                        React.createElement("div", { className: "menu-item-inner-text" }, el.name),
                        el.alertIcon && React.createElement(Icon_1.default, { icon: "alert_menu_icon" }))));
                return (React.createElement("li", { key: el.name, className: el.active ? 'active' : '' }, el.externalLink === false ?
                    React.createElement(react_router_dom_1.Link, { to: el.url, onClick: props.closeMobileMenu }, inner) : React.createElement("a", { href: el.url }, inner)));
            }),
            React.createElement("li", { key: "logout", className: "log-out" },
                React.createElement("button", { onClick: props.logOut.function, type: "button" },
                    React.createElement(MenuIcon_1.default, { type: "ICON", icon: "log-out" }),
                    React.createElement("span", { className: "menu-item-inner" }, props.logOut.label)))));
    }
    function isCollapsable() {
        return (props.type === 'DATA' &&
            props.availableModes.filter((m) => m.mode !== 'enduser' && m.mode !== 'tenant').length >= 1 ||
            getInitialCollapsedState());
    }
    function setCollapsedCookie(isCollapsed) {
        const date = new Date();
        // 90 days expiry time
        date.setTime(date.getTime() + (90 * 24 * 60 * 60 * 1000));
        document.cookie = `isMenuCollapsed=${isCollapsed};expires=${date.toUTCString()};path=/;`;
    }
    function getInitialCollapsedState() {
        if (isTabletOrMobile) {
            return false;
        }
        const cookie = document.cookie
            .split(';')
            .map((c) => c.trim())
            .find((c) => c.startsWith('isMenuCollapsed'));
        if (cookie) {
            return (cookie.split('=')[1] === 'true');
        }
        return false;
    }
    function activeUrl(items) {
        return items
            .filter((el) => el.active || isUrlPartOfPath(el.url))
            .map((el) => el.url)
            .sort((a, b) => b.length - a.length)[0] || '';
    }
    function isUrlPartOfPath(url) {
        return location.pathname.indexOf(url) > -1;
    }
};
exports.default = Menu;
//# sourceMappingURL=Menu.js.map